<template>
  <a type="button"
     v-if="showComponent" :disabled="!enableComponent || disabled"
     :title="qaAble ? showIfHasPermission?.toString() : null"
     :key="componentRefresh"
     :class="['float-button', cColor, classes]"
     @click="onClick">
    <i :class="[`${classIcon} float-button-icon`]" v-if="classIcon"></i>
  </a>
</template>


<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name: "ks-button-floating",
  mixins: [checkPermissions],

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    classIcon: {
      type: String,
      default: null
    },
    classes: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    }
  },
  methods: {
    onClick(params) {
      this.$emit('onClick', params);
    }
  },
  computed: {
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    },
    cColor() {
      return this.color ? `bg-${this.color}` : 'bg-primary'
    }
  }
}
</script>

<style>

.float-button {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 70px;
  right: 40px;
  background-color: #0C9;
  color: #FFF;
  border-radius: 50px;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
}

.float-button-icon {
  margin-top: 22px;
  font-size: 18px;
}

</style>
